module.exports = __webpack_public_path__ + "static/media/upgrade_websights.dbf554d0.png";